
const TabPanel = ({ children, value, index, ...other }) => {

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`consultas-painel-${index}`}
            aria-labelledby={`paibnel-consulta-${index}`}
            {...other}
        >
            {value === index && (
                children
            )}
        </div>
    )

}

export default TabPanel;